import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import KitchenPage from 'modules/restaurant/kitchen/KitchenPage';

export default function DashRestaurantKitchen() {
    return (
        <DashEstablishmentContainer title='Pedidos'>
            <KitchenPage />
        </DashEstablishmentContainer>
    );
}
